import { Component, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Countries } from '../../../enums/countries';
import { CustomerType } from '../../../enums/customer-type';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { EnrollmentService } from '../../../services/enrollment.service';
import { GeneralService } from '../../../services/general.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { CustomerService } from '../../../services/customer.service';
import { Customer } from '../../../interfaces/customer';

@Component({
    selector: 'app-k-review',
    templateUrl: './k-review.component.html',
    styleUrls: ['./k-review.component.scss'],
    standalone: false
})
export class KReviewComponent {
     companyInfo!: FormGroup;
     companyBillingInfo!: FormGroup;
     companyInfoISP!: FormGroup;
     confirmBillingEmail:string = "";
     confirmEmail_:string = "";
     billingIsSame:string = 'true';
     _emailIsDup:boolean = false;
     _emailTesting:boolean = false;
     _emailBillingTesting:boolean = false;
     _emailIsBillingDup:boolean = false;
     inEdit:boolean = false;
     customerType = CustomerType;
     isVerifying: boolean = false;
     existingCompanyName: string = '';
     existingCompanyAddress: string = '';
     
     countriesList: any = [];
     stateList: any = [];

     countries = Countries;
     isLoading = true;

     public haveUSDOT: string = "na";
     public inUse: boolean = false;
     public inUseTesting: boolean = false;
     public testedDOT: boolean = false;

     public DOTisDurity: boolean = false;
     public DOTRegexIsValid: boolean = false;
     powerInvalid: string = '';
     
     @ViewChild('PossibleDuplicateModal') possibleDuplicateModal: TemplateRef<any> | undefined;

     constructor (public generalService: GeneralService,
          public enrollmentService: EnrollmentService,
          private router: Router,
          public modalService: NgbModal,
          public customerService: CustomerService
     ) {
          if (this.enrollmentService.newCustomer!.customerType === this.customerType.AH) {
               if (this.enrollmentService.newCustomer!.dotId !== "") {
                    this.haveUSDOT = 'true';
               } else {
                    this.haveUSDOT = 'false';
               }
          }

          this.billingIsSame = this.enrollmentService.billingUserSame ;

          const countries = enrollmentService.getCountries();
          countries.subscribe((v: any) => this.loadCountries(v));

          const states = enrollmentService.getStates();
          states.subscribe((v: any) => this.loadStates(v));

          this.confirmEmail_ = this.enrollmentService.powerUser!.email;
          if(this.enrollmentService.billingUserSame === "false"){
               this.confirmBillingEmail = this.enrollmentService.billingUser!.email;
          }
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ], 
          _cancelLinkRoute: '',
          backLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          continueLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          totalSteps: 1,
          type: 'enroll',
          visualProgressStep(currentPane: number) {;
            // not implimented
            return 1;
          }
     }

     ngOnInit(): void {
          const countryZipPattern = (this.enrollmentService.newCustomer?.country?.toString() === 'USA' ?
               /(^\d{5}(-\d{4})?$)/ : 
                /(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}\d{1}[A-Za-z]{1}\d{1}$)/
               )
          this.companyInfo = new FormGroup({
               name: new FormControl(this.enrollmentService.newCustomer!.name, [
                    Validators.required,
                    Validators.maxLength(100),
                    Validators.pattern(/^([a-zA-Z0-9 '.,&\$\%-]*)$/) 
               ]),
               addressLine1: new FormControl(this.enrollmentService.newCustomer!.address!.addressLine1, [
                    Validators.required,
                    Validators.maxLength(34),
                    Validators.pattern(/^([a-zA-Z0-9 '.\/]*)$/) 
               ]),
               addressLine2: new FormControl(this.enrollmentService.newCustomer!.address!.addressLine2, [
                    Validators.maxLength(14),
                    Validators.pattern(/^([a-zA-Z0-9 '.\/]*)$/) 
               ]),
               
               country: new FormControl(this.enrollmentService.newCustomer!.country, [
                    Validators.required,
                    Validators.pattern(/^(?!mexico$)/i) 
               ]),
               city: new FormControl(this.enrollmentService.newCustomer!.address!.city, [
                    Validators.required,
                    Validators.maxLength(30),
                    Validators.pattern(/^([a-zA-Z0-9 '.\/]*)$/) 
               ]),
               state: new FormControl(this.enrollmentService.newCustomer!.address!.state, [
                    Validators.required
               ]),
               zip: new FormControl(this.enrollmentService.newCustomer!.address!.zip, [
                    Validators.required,
                    Validators.pattern(countryZipPattern)
               ]),
               firstName: new FormControl(this.enrollmentService.powerUser!.firstName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastName: new FormControl(this.enrollmentService.powerUser!.lastName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               email: new FormControl(this.enrollmentService.powerUser!.email, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               confirmEmail: new FormControl(this.confirmEmail_, [
                    Validators.maxLength(50),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               primaryPhoneNumber: new FormControl(this.enrollmentService.powerUser!.primaryPhoneNumber, [
                    Validators.required,
                    Validators.minLength(10),
                    Validators.maxLength(10),
               ]),
               faxNumber: new FormControl(this.enrollmentService.powerUser!.faxNumber, [
                    Validators.minLength(10)
               ])
          });

          this.companyBillingInfo = new FormGroup({
                    
               firstNameBilling: new FormControl(this.enrollmentService.billingUser!.firstName, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastNameBilling: new FormControl(this.enrollmentService.billingUser!.lastName, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(15000),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               emailBilling: new FormControl(this.enrollmentService.billingUser!.email, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               confirmEmailBilling: new FormControl(this.confirmBillingEmail, [
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               primaryPhoneNumberBilling: new FormControl(this.enrollmentService.billingUser!.primaryPhoneNumber, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),      
                    Validators.minLength(10),
                    Validators.maxLength(10),
               ]),
               faxNumberBilling: new FormControl(this.enrollmentService.billingUser!.faxNumber, [
                    Validators.minLength(10)
               ])
          });

          this.companyInfoISP = new FormGroup({
               ispEstimatedCustomers: new FormControl(this.enrollmentService.newCustomer!.ispEstimatedCustomers, [
                    Validators.required,
                    Validators.max(999999999),
                    Validators.min(1),
                    Validators.pattern(/^([0-9]*)$/) 
               ]),
               ispAnnualScreenings: new FormControl(this.enrollmentService.newCustomer!.ispAnnualScreenings, [
                    Validators.required,
                    Validators.max(999999999),
                    Validators.min(1),
                    Validators.pattern(/^([0-9]*)$/) 
               ])
          });  
          setTimeout(() => this.scrollToTop(), 500);
          this.isLoading = false;
     }

     get ispEstimatedCustomers() { return this.companyInfoISP!.get('ispEstimatedCustomers'); }
     get ispAnnualScreenings() { return this.companyInfoISP!.get('ispAnnualScreenings'); };  

     get name() { return this.companyInfo!.get('name'); }
     get country() { return this.companyInfo!.get('country'); }

     get addressLine1() { return this.companyInfo!.get('addressLine1'); }
     get addressLine2() { return this.companyInfo!.get('addressLine2'); };  
     get city() { return this.companyInfo!.get('city'); };  
     get state() { return this.companyInfo!.get('state'); };  
     get zip() { return this.companyInfo!.get('zip'); };  

     get firstName() { return this.companyInfo!.get('firstName'); }
     get lastName() { return this.companyInfo!.get('lastName'); }
     get email() { return this.companyInfo!.get('email'); }
     get confirmEmail() { return this.companyInfo!.get('confirmEmail'); }
     get primaryPhoneNumber() { return this.companyInfo!.get('primaryPhoneNumber'); }
     get faxNumber() { return this.companyInfo!.get('faxNumber'); }

     get emailIsDup() {return this._emailIsDup;}
     get emailTesting(){return this._emailTesting; }

     
     get firstNameBilling() { return this.companyBillingInfo!.get('firstNameBilling'); }
     get lastNameBilling() { return this.companyBillingInfo!.get('lastNameBilling'); }
     get emailBilling() { return this.companyBillingInfo!.get('emailBilling'); }
     get confirmEmailBilling() { return this.companyBillingInfo!.get('confirmEmailBilling'); }
     get primaryPhoneNumberBilling() { return this.companyBillingInfo!.get('primaryPhoneNumberBilling'); }
     get faxNumberBilling() { return this.companyBillingInfo!.get('faxNumberBilling'); }

     get emailIsBillingDup() {return this._emailIsBillingDup;}
     get emailBillingTesting(){return this._emailBillingTesting;}

     loadCountries(value: []) {
          this.countriesList = value;
     }

     loadStates(value: string[]) {
          const index = value.indexOf("PQ");
          if(index > -1){
              value[index] = "QC";
          }
          const index2 = value.indexOf("NF");
          if(index2 > -1){
              value[index2] = "NL";
          }
          this.stateList = value;
     }

     testPowerNumber(){
          var pattern = /^[0-9]*$/;
          if(this.enrollmentService.newCustomer!.numberOfPowerUnits === null || this.enrollmentService.newCustomer!.numberOfPowerUnits! < 0){
               this.powerInvalid ="required";
          }else if(this.enrollmentService.newCustomer!.numberOfPowerUnits! > 1000000000){
               this.powerInvalid ="lthaneto";
          }else if(this.enrollmentService.newCustomer!.numberOfPowerUnits && !pattern.test(this.enrollmentService.newCustomer!.numberOfPowerUnits!.toString())){
               this.powerInvalid ="notNumber";
          }else {
               this.powerInvalid ="";
          }
     }

     toggleReviewEdit() {
          this.inEdit = (!this.inEdit);
          if (this.inEdit === false) {
               // Just saved. Check for duplicate customer.
               this.checkForExistingCustomer();
          }
     }

     testPrimaryEmail() {
          
          this._emailIsDup = false;
          if(this.companyInfo!.get('email')?.valid){     
               this._emailTesting = true;
               this.enrollmentService.testEmail(this.companyInfo!.get('email')?.value)
               .subscribe((v: any) => {{
                         if(v === 'true'){
                              this._emailIsDup = true;
                         }else{
                              this._emailIsDup = false;
                         }
                         this._emailTesting = false;
                    }}
               );
          }
           
     }

     testBillingEmail() {
          if(this.companyBillingInfo!.get('emailBilling')?.valid){
               this._emailIsBillingDup = false;
               if(this.companyInfo!.get('email')?.valid){
                    this._emailBillingTesting = true;
                    this.enrollmentService.testEmail(this.companyBillingInfo!.get('emailBilling')?.value)
                    .subscribe((v: any) => {{
                              if(v === 'true'){
                                   this._emailIsBillingDup = true;
                              }else{
                                   this._emailIsBillingDup = false;
                              }
                              this._emailBillingTesting = false;
                         }}
                    );
               }
          }
     }

     testDot() {
          const regex: RegExp = /^([0-9]*)$/;
          this.DOTisDurity = true;
          this.DOTRegexIsValid = regex.test(this.enrollmentService.newCustomer!.dotId!);
          if (this.enrollmentService.newCustomer?.dotId !== '' && this.DOTRegexIsValid) {
               this.inUseTesting = true;
               const useTest = this.enrollmentService.testDOT(this.enrollmentService.newCustomer!.dotId!);
               useTest.subscribe(
                    response => {
                         this.testResponse(response)
                    },
                    error => {
                         console.error('Error:', error);
                    }
               );
          } else {
               this.inUseTesting = false;
               this.inUse = false;
               this.testedDOT = false;
          }
     }

     testResponse(response: any) {
          this.inUse = (response === "true");
          this.enrollmentService.newCustomer!.customerType = CustomerType.AH;
          this.inUseTesting = false;
          this.testedDOT = true;
     }


     updateIsSame(val: string) {
          this.billingIsSame = val;
          if(this.billingIsSame === 'false'){
               this.enrollmentService.iniBillingUser();
               this.companyBillingInfo = new FormGroup({
                    
                    firstNameBilling: new FormControl(this.enrollmentService.billingUser!.firstName, [
                         Validators.required,
                         Validators.maxLength(50),
                         Validators.pattern(/^([a-zA-Z ']*)$/)
                    ]),
                    lastNameBilling: new FormControl(this.enrollmentService.billingUser!.lastName, [
                         Validators.required,
                         Validators.maxLength(15000),
                         Validators.pattern(/^([a-zA-Z ']*)$/)
                    ]),
                    emailBilling: new FormControl(this.enrollmentService.billingUser!.email, [
                         Validators.required,
                         Validators.maxLength(100),
                         Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
                    ]),
                    confirmEmailBilling: new FormControl(this.confirmBillingEmail, [
                         Validators.required,
                         Validators.maxLength(100),
                         Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
                    ]),
                    primaryPhoneNumberBilling: new FormControl(this.enrollmentService.billingUser!.primaryPhoneNumber, [
                         Validators.required,      
                         Validators.minLength(10),
                         Validators.maxLength(10),
                    ]),
                    faxNumberBilling: new FormControl(this.enrollmentService.billingUser!.faxNumber, [
                         Validators.minLength(10)
                    ])
               });
          }
     }

     getTranslator(val: string): string {
          let translation: string = this.generalService.getTranslation(val,'base');
          if (translation === undefined) {
              translation = this.generalService.getTranslation(val,'base');
          }
          return translation;
      }

     pageValid(){
          if(this._emailIsDup === true || this._emailIsBillingDup === true){return 'true'};
          
          const regex: RegExp = /^([0-9]*)$/;
          this.DOTRegexIsValid = regex.test(this.enrollmentService.newCustomer!.dotId!);
          if(this.haveUSDOT === "true"  && 
                                        (
                                             !this.DOTRegexIsValid || 
                                             this.enrollmentService.newCustomer!.dotId === '' || 
                                             this.enrollmentService.newCustomer!.dotId!.length >= 8 || 
                                             (this.testedDOT && this.inUse)
                                        )
          ){
               return 'true'
          }

          if(this.companyInfo.valid && this.email!.value !== this.confirmEmail!.value){
               return 'true'
          };
          
          if(this.billingIsSame === 'false' && (this.companyBillingInfo.valid && (this.emailBilling!.value !== this.confirmEmailBilling!.value))){
               return 'true'};
          
          if(this.billingIsSame === 'false' && (this.companyBillingInfo.valid && (this.emailBilling!.value === this.email!.value))){
               return 'true'
          };

          if(this.enrollmentService.newCustomer!.customerType === this.customerType.AH){
               if(this.enrollmentService.newCustomer!.interIntraState === ''){
                    return 'true'
               }else if(this.enrollmentService.newCustomer!.numberOfPowerUnits === null || 
                    this.enrollmentService.newCustomer!.numberOfPowerUnits === undefined){
                    return 'true'
               }else if(this.enrollmentService.newCustomer!.numberOfPowerUnits! < 0 ||
                    this.enrollmentService.newCustomer!.numberOfPowerUnits! > 1000000000 ){
                    return 'true'
               }else if(this.powerInvalid !== ""){
                    return 'true'
               }
          }else{
               if(this.companyInfoISP.invalid){
                    return 'true'
               }
          }
          if(this.companyInfo.valid && this.billingIsSame === 'true'){
               return null;
          }else if(this.companyInfo.valid && (this.billingIsSame === 'false' && this.companyBillingInfo.valid)){
               return null;
          }
          return 'true'
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnDestroy() {
          this.enrollmentService.billingUserSame = this.billingIsSame;
          if(this.companyInfo.dirty){
               this.enrollmentService.newCustomer!.name = this.companyInfo!.get('name')?.value;
               this.enrollmentService.newCustomer!.country = this.companyInfo!.get('country')?.value;
               const cid = Countries[this.enrollmentService.newCustomer!.country!]
               this.enrollmentService.newCustomer!.address!.countryId = parseInt(cid);
               this.enrollmentService.newCustomer!.address!.country = this.companyInfo!.get('country')?.value;

               
               this.enrollmentService.powerUser!.firstName = this.companyInfo!.get('firstName')?.value;
               this.enrollmentService.powerUser!.lastName = this.companyInfo!.get('lastName')?.value;
               this.enrollmentService.powerUser!.email = this.companyInfo!.get('email')?.value;
               this.enrollmentService.powerUser!.primaryPhoneNumber = this.companyInfo!.get('primaryPhoneNumber')?.value;
               this.enrollmentService.powerUser!.faxNumber = this.companyInfo!.get('faxNumber')?.value;

               this.enrollmentService.newCustomer!.address!.addressLine1 = this.companyInfo!.get('addressLine1')?.value;
               this.enrollmentService.newCustomer!.address!.addressLine2 = this.companyInfo!.get('addressLine2')?.value;
               this.enrollmentService.newCustomer!.address!.city = this.companyInfo!.get('city')?.value;
               this.enrollmentService.newCustomer!.address!.state = this.companyInfo!.get('state')?.value;
               this.enrollmentService.newCustomer!.address!.zip = this.companyInfo!.get('zip')?.value;
               this.enrollmentService.newCustomer!.city = this.companyInfo!.get('city')?.value;
               this.enrollmentService.newCustomer!.state = this.companyInfo!.get('state')?.value;
               this.enrollmentService.newCustomer!.zip = this.companyInfo!.get('zip')?.value;

          }
          if(this.billingIsSame === 'false' && this.companyBillingInfo.dirty){
               this.enrollmentService.billingUser!.firstName  = this.companyBillingInfo!.get('firstNameBilling')?.value;
               this.enrollmentService.billingUser!.lastName = this.companyBillingInfo!.get('lastNameBilling')?.value;
               this.enrollmentService.billingUser!.email = this.companyBillingInfo!.get('emailBilling')?.value;
               this.enrollmentService.billingUser!.primaryPhoneNumber = this.companyBillingInfo!.get('primaryPhoneNumberBilling')?.value;
               this.enrollmentService.billingUser!.faxNumber = this.companyBillingInfo!.get('faxNumberBilling')?.value;
          }

          if(this.companyInfoISP.dirty){
               this.enrollmentService.newCustomer!.ispEstimatedCustomers = this.companyInfoISP!.get('ispEstimatedCustomers')?.value;
               this.enrollmentService.newCustomer!.ispAnnualScreenings = this.ispAnnualScreenings!.get('ispAnnualScreenings')?.value;
          }
          this.enrollmentService.foundDupEmails = false;
          this.enrollmentService.saveToLocal();
     }

     checkForExistingCustomer() {
          this.scrollToTop();
          this.isVerifying = true;
          if (this.enrollmentService.newCustomer!.name) {
               const matchPromise = this.customerService.getExistingCustomer(
                    this.enrollmentService.newCustomer!.name,
                    this.enrollmentService.newCustomer!.address!.country!.toString(),
                    this.companyInfo!.get('state')?.value);
               matchPromise.subscribe((response: Customer | any) => this.displayExistingCustomer(response));
          }
     }

     displayExistingCustomer(existingCustomer: Customer | any) {
          if (existingCustomer && existingCustomer.dbaName) {
               this.existingCompanyName = existingCustomer.dbaName;
               this.existingCompanyAddress = `${existingCustomer.street} ${existingCustomer.city}, ${existingCustomer.state} ${existingCustomer.zip} ${existingCustomer.country}`;

               let ngbModalOptions: NgbModalOptions = {
                    backdrop: 'static',
                    keyboard: false,
                    ariaLabelledBy: 'possibleDuplicateTitle'
               };
               this.modalService.open(this.possibleDuplicateModal, ngbModalOptions);
               this.isVerifying = false;
          } else {
               // No customer match found. 
               this.continueEnrollment();
          }
     }

     continueEnrollment() {
          this.isVerifying = false;
          this.modalService.dismissAll();
          this.router.navigateByUrl('/signup/16');
     }

     cancelDuplicate() {
          this.modalService.dismissAll();
          this.router.navigateByUrl('/');
     }
}
